import { useContext } from 'react';
import { SearchResultsContext } from 'site-modules/personalized-search/context/search-results-context/search-results-context';

export function useSearchResults() {
  return useContext(SearchResultsContext);
}
